<!--
 * @Author: your name
 * @Date: 2020-12-11 11:07:06
 * @LastEditTime: 2022-12-07 10:51:05
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/tab/index.vue
-->
<style scoped lang="sass">
.app_container

</style>

<style lang="sass" scoped>
::v-deep
  .van-button--primary
    background-color: var(--menu-primary-background-colour)
    border: none

  .van-button--disabled
    opacity: 1
    background-color: rgb(221, 221, 221) !important

.submit
  height: 56px
  width: 100%
  font-size: 15px
  border-radius: 5px !important

.icon_container
  display: flex
  justify-content: center
  align-items: center
  height: 70px
  width: 70px
  background-color: #EFEFF0
  border-radius: 50%

.icon
  height: 43px

.title
  padding-top: 23px
  padding-bottom: 28px
  max-width: 256px
  font-size: 12px
  text-align: center
  color: var(--menu-primary-text-colour)

.code
  display: flex !important
  justify-content: space-between !important
  align-items: center !important
  height: 54px !important
  width: 100% !important
  margin-bottom: 26px !important
  flex-direction: row !important
  flex-wrap: nowrap !important

::v-deep
  .__otp_input_component
    height: 54PX
    width: 54PX
    margin: 0 5PX
</style>

<template lang="pug">
.app_container
  .title.o7 {{ title }}
  otp-input.code(v-model="code")

  van-button.submit.b.ls1(
    type="primary"
    :disabled="disabled"
    @click="submitButton"
  ) {{ t('submit', 'SUBMIT') }}

</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { emitLoading } from 'utils/decorators'
import { t } from '@/utils/language'
import { getTabDetail } from 'api/tab'

@Component({
  watch: {
    code(val) {
      this.disabled = val.length !== 4
    }
  },

  props: {
    venueId: {
      type: String
    },

    tabId: {
      type: [String, Number]
    },

    showTabDialog: {
      type: Boolean
    },

    showTabDialogType: {
      type: String
    }
  }
})

class TabInputCode extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  code = ''
  title = t('enter_last_four_digits', 'Please enter the last four digits of your phone number to finish setting up your tab.')
  disabled = true

  @emitLoading('input')
  async submitButton() {
    try {
      const res = await this._getTabDetail()
      if (res.status !== 0) {
        this.jumpToMenu()
      } else {
        this.jumpToTabInfo()
      }
    } catch (error) {
      console.error(error)
    } finally {
      // 应该是成功以后 save code
      this.saveTabPassCode()
      this.closeLoading()
    }
  }

  jumpToMenu() {
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabId}/menu`,
    })
  }

  closeLoading() {
    this.$emit('input', false)
  }

  saveTabPassCode() {
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', this.code)
  }

  async _getTabDetail() {
    const res = await getTabDetail({
      tabId: this.tabId,
      venueId: this.venueId,
      passCode: this.code,
    })
    return res
  }

  jumpToTabInfo() {
    this.$router.push(`/v/${this.venueId}/tab-admin/${this.tabId}/info`)
  }
}

export default TabInputCode
</script>
